module.exports = __webpack_public_path__ + "img/nanjing.17379a15.png";